/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationSharedSelectiveProcessAdmissionTypeList200,
  GetApiV1CourseregistrationSharedSelectiveProcessAdmissionTypeList401,
  GetApiV1CourseregistrationSharedSelectiveProcessAdmissionTypeList500,
  GetApiV1CourseregistrationSharedSelectiveProcessAdmissionTypeListQueryResponse,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedSelectiveProcessAdmissionTypeList.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationSharedSelectiveProcessAdmissionTypeList200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedSelectiveProcessAdmissionTypeList200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationSharedSelectiveProcessAdmissionTypeList401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedSelectiveProcessAdmissionTypeList401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationSharedSelectiveProcessAdmissionTypeList500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedSelectiveProcessAdmissionTypeList500>;

export const getApiV1CourseregistrationSharedSelectiveProcessAdmissionTypeListQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationSharedSelectiveProcessAdmissionTypeList200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedSelectiveProcessAdmissionTypeListQueryResponse>;
